/**
 * A day is "closed" (the `day-done` breakpoint trigger, see today-view.tsx) only when
 * it is TODAY, has at least one scheduled habit, and every scheduled habit is done.
 * Marking one of several habits is not a closure; past days never close.
 */
export function isDayClosed(input: { isToday: boolean; scheduled: number; done: number }): boolean {
  return input.isToday && input.scheduled > 0 && input.done === input.scheduled;
}
